// @ts-nocheck
import { createPropertyTypeReducer } from 'app/shared/utils/sitemapUtils';

const propertyTypeReducer = createPropertyTypeReducer({
  neighborhood: 'neighborhoods',
  zip: 'zip codes',
  county: 'counties',
});

// Helper function to check if a property type section has any data
const hasData = (propertyTypeData) => {
  if (!propertyTypeData || typeof propertyTypeData !== 'object') {
    return false;
  }

  // Check if any geographic category has valid areas (including 0 listing count areas)
  return Object.values(propertyTypeData).some((geoTypeAreas) => Array.isArray(geoTypeAreas) && geoTypeAreas.length > 0);
};

// Helper function to filter out empty geographic categories
// Note: areaGroupMapper now includes areas with 0 listings, so this only filters
// geographic categories that have no valid areas at all (not even 0-listing areas)
const filterEmptyGeoTypes = (propertyTypeData) => {
  if (!propertyTypeData || typeof propertyTypeData !== 'object') {
    return {};
  }

  const filtered = {};
  Object.entries(propertyTypeData).forEach(([geoType, areas]) => {
    if (Array.isArray(areas) && areas.length > 0) {
      filtered[geoType] = areas;
    }
  });

  return filtered;
};

const CitySitemap = function (sitemap = [], listings = []) {
  // Process each property type and only include if it has data
  const apartmentsData = sitemap
    .filter((item) => item.header === 'apartments-for-rent')
    .reduce(propertyTypeReducer, {});
  const filteredApartments = filterEmptyGeoTypes(apartmentsData);
  if (hasData(filteredApartments)) {
    this.apartments = filteredApartments;
  }

  const housesData = sitemap.filter((item) => item.header === 'houses-for-rent').reduce(propertyTypeReducer, {});
  const filteredHouses = filterEmptyGeoTypes(housesData);
  if (hasData(filteredHouses)) {
    this.houses = filteredHouses;
  }

  const condosData = sitemap.filter((item) => item.header === 'condos-for-rent').reduce(propertyTypeReducer, {});
  const filteredCondos = filterEmptyGeoTypes(condosData);
  if (hasData(filteredCondos)) {
    this.condos = filteredCondos;
  }

  const affordableApartmentsData = sitemap
    .filter((item) => item.header === 'affordable-apartments-for-rent')
    .reduce(propertyTypeReducer, {});
  const filteredAffordableApartments = filterEmptyGeoTypes(affordableApartmentsData);
  if (hasData(filteredAffordableApartments)) {
    this['affordable apartments'] = filteredAffordableApartments;
  }

  const forRentByOwnerData = sitemap
    .filter((item) => item.header === 'for-rent-by-owner')
    .reduce(propertyTypeReducer, {});
  const filteredForRentByOwner = filterEmptyGeoTypes(forRentByOwnerData);
  if (hasData(filteredForRentByOwner)) {
    this['for rent by owner'] = filteredForRentByOwner;
  }

  const roomsForRentData = sitemap.filter((item) => item.header === 'rooms-for-rent').reduce(propertyTypeReducer, {});
  const filteredRoomsForRent = filterEmptyGeoTypes(roomsForRentData);
  if (hasData(filteredRoomsForRent)) {
    this['rooms for rent'] = filteredRoomsForRent;
  }

  // Handle multi-family buildings separately - only include if there are listings
  if (Array.isArray(listings) && listings.length > 0) {
    const multiFamilyListings = listings.map((listing) => {
      return {
        name: listing.displayName,
        uriV2: listing.uriV2,
        phrase: `Building in ${listing?.address?.city}`,
      };
    });

    this['multi-family buildings'] = {
      'multi-family buildings': multiFamilyListings,
    };
  }
};

export default CitySitemap;
